import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { GoogleLogin } from '@react-oauth/google'
import './Login.css'

function Cadastro() {
    const [loading, setLoading] = useState(false)
    const [erro, setErro] = useState('')
    const navigate = useNavigate()
    const { loginGoogle } = useAuth()

    return (
        <div className="auth-page">
            <div className="auth-container">
                <div className="auth-card">
                    <div className="auth-header">
                        <Link to="/" className="auth-logo">
                            <img src="/logo/agroov-completa.jpg" alt="Agroov" style={{ maxWidth: '180px', height: 'auto', marginBottom: '1.5rem', borderRadius: 'var(--radius-md)' }} />
                        </Link>
                        <h1>Criar Conta</h1>
                        <p>Junte-se ao marketplace do produtor rural brasileiro</p>
                    </div>

                    {erro && (
                        <div className="alert alert-error">
                            {erro}
                        </div>
                    )}

                    <div style={{ textAlign: 'center', marginTop: '1.5rem', marginBottom: '1.5rem' }}>
                        <p style={{ color: 'var(--color-text-secondary)', fontSize: '0.95rem', lineHeight: '1.6' }}>
                            Crie sua conta de forma rápida e segura usando seu Google. Seus dados ficam protegidos pela autenticação do Google.
                        </p>
                    </div>

                    <div className="auth-social" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                        <GoogleLogin
                            onSuccess={async (credentialResponse) => {
                                try {
                                    setLoading(true)
                                    await loginGoogle(credentialResponse.credential)
                                    navigate('/completar-perfil')
                                } catch (error) {
                                    setErro(error.message || 'Erro ao criar conta com o Google')
                                } finally {
                                    setLoading(false)
                                }
                            }}
                            onError={() => {
                                setErro('Falha na autenticação com o Google')
                            }}
                            theme="filled_blue"
                            shape="pill"
                            locale="pt_BR"
                            text="signup_with"
                        />
                    </div>

                    {loading && (
                        <div style={{ textAlign: 'center', marginTop: '1rem', color: 'var(--color-text-secondary)' }}>
                            Criando conta...
                        </div>
                    )}

                    <div className="auth-footer">
                        <p>
                            Já tem uma conta?{' '}
                            <Link to="/login">Fazer login</Link>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Cadastro
